"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _createButton = require("./create-button");

var _createButton2 = _interopRequireDefault(_createButton);

var _createSvgIcon = require("./createSvgIcon");

var _createSvgIcon2 = _interopRequireDefault(_createSvgIcon);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var icon = function icon(props) {
  return _react2.default.createElement("svg", props, _react2.default.createElement("path", {
    d: "M.176 224L.001 67.963l192-26.072V224H.176zM224.001 37.241L479.937 0v224H224.001V37.241zM479.999 256l-.062 224-255.936-36.008V256h255.998zM192.001 439.918L.157 413.621.147 256h191.854v183.918z",
    fill: "#FFF"
  }));
};

icon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "512",
  height: "512",
  viewBox: "0 0 480 480"
};
var config = {
  activeStyle: {
    background: "rgb(0, 137, 255)"
  },
  icon: (0, _createSvgIcon2.default)(icon),
  style: {
    background: "rgb(50, 159, 253)"
  },
  text: "Login with Microsoft"
};
var MicrosoftLoginButton = (0, _createButton2.default)(config);
exports.default = MicrosoftLoginButton;